import styled from 'styled-components';
import { COLORS, MQS, SHADOWS } from '../../app/common/constants/styles';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-color: ${COLORS.white};
    border-radius: 4px;
    box-shadow: ${SHADOWS.level1};
    padding: 20px;
`;

export const TopTitleWrapper = styled.div`
    background-color: ${COLORS.warningBackground};
    padding: 30px;
    border-radius: 4px;
`;

export const Title2 = styled.h2`
    color: ${COLORS.redTitle};
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0;
    text-indent: 0px;
`;

export const TopDescription = styled.p`
    color: ${COLORS.grey5};
    font-size: 1.5rem;
    font-weight: 300;
    margin: 0;
    margin-top: 15px;
    line-height: 1.2;
`;

export const SubWrapper = styled.div`
    & > p {
        font-size: 0.875rem;
        line-height: 1.5;
        margin: 0;
    }
`;
export const Title5 = styled.h5`
    color: #000000;
    font-weight: 800;
    line-height: 1.5;
    margin: 0;
    margin-top: 15px;
    font-size: 0.875rem;
`;
export const Title3 = styled.h3`
    color: #df0101;
    font-weight: 800;
    line-height: 1.5;
    margin: 0;
    margin-top: 15px;
    font-size: 0.875rem;
`;

export const UlWrapper = styled.ul`
    padding: 0;
    list-style-type: disc;
    margin: 20px;
`;
export const UlLi = styled.li`
    color: ${COLORS.dark};
    font-size: 0.875rem;
    line-height: 1.5;
`;

export const UlLiLink = styled.a`
    color: ${COLORS.linkBlue};
    cursor: pointer;
    transition: font-weight 200ms ease-in;
    text-decoration: underline;
    white-space: nowrap;
    &:hover {
        font-weight: bold;
    }
`;

export const UnderLine = styled.div`
    border-bottom: 1px solid ${COLORS.lightGrey};
    margin: 40px 0;
`;

export const BottomTitle = styled.h4`
    color: ${COLORS.dark};
    font-size: 1.5rem;
    font-weight: 300;
    margin: 0;
    margin-bottom: 20px;
`;

export const CancelSpace = styled.div`
    display: flex;
    height: 15px;
`;

export const Space40 = styled.div`
    display: flex;
    height: 40px;
`;

export const DeleteLinkWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 30px;
    gap: 50px;

    @media (max-width: ${MQS.mq2Min}) {
        justify-content: space-between;
    }
`;
export const DeleteLink = styled.a`
    margin-left: 50px;
    font-size: 0.9375rem;
    color: ${COLORS.grey7};
    text-decoration: none;
    display: inline-flex;
    align-items: flex-end;
    justify-content: center;

    &:hover {
        color: ${COLORS.rakutenRed};
    }
`;

export const Description = styled.p``;

export const TextWrapper = styled.span``;

export const MarkdownWrapper = styled.div`
    height: calc(100vh - 12em);
    padding: 1.5rem 0;
    @media (max-width: ${MQS.mq2Min}) {
        min-height: 80vh;
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
`;
